export default "__VITE_ASSET__BSLP73Zj__";